import { render } from "./CustomSearch.vue?vue&type=template&id=95bc6be4&scoped=true"
import script from "./CustomSearch.vue?vue&type=script&lang=js"
export * from "./CustomSearch.vue?vue&type=script&lang=js"

import "./CustomSearch.vue?vue&type=style&index=0&id=95bc6be4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95bc6be4"]])

export default __exports__